import script from "./detailVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./detailVideo.vue?vue&type=script&setup=true&lang=js"

import "./detailVideo.vue?vue&type=style&index=0&id=7558df32&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7558df32"]])

export default __exports__